import Vue from "vue";
import Vuex from "vuex";

import dashboard from "./dashboard/dashboard";
import idpExamination from "./idp-examination/idp-examination";
import business from "./master-data/business-unit/business-unit";
import coaching from "./master-data/coaching/coaching";
import competency from "./master-data/competency/competency";
import competencyOptions from "./master-data/competency/competency-options";
import roleCompetency from "./master-data/role-competency/role-competency";
import employee from "./master-data/employee/employee";
import position from "./master-data/position/position";
import projectRole from "./master-data/project-role/project-role";
import projectType from "./master-data/project-type/project-type";
import project from "./master-data/project/project";
import trainingMethod from "./master-data/training-method/training-method";
import trainingProvider from "./master-data/training-provider/training-provider";
import trainingType from "./master-data/training-type/training-type";
import training from "./master-data/training/training";
import trainingCategory from "./master-data/training-category/training-category";
import menu from "./menu/menu";
import myIdp from "./myidp/myidp";
import role from "./role/role";
import idpPeriod from "./settings/idpPeriod";
import tnaPeriod from "./settings/tna-period";
import users from "./users/users";
import notificationEvent from "./settings/notification-event";
import notificationTemplate from "./settings/notification-template";
import userRoleManagement from "./settings/user-role-management";
import header from "./header/header";
import lsp from "./master-data/lsp/lsp";
import ldp from "./master-data/ldp/ldp";
import certificate from "./master-data/certificate/certificate";
import courseMapping from "./master-data/course-mapping/course-mapping";
import courseMappingFilters from "./master-data/course-mapping/filters";
import courseMappingMitraFilters from "./master-data/course-mapping-mitra/filters";
import positionLevel from "./master-data/position-level/position-level";
import userManagementMitra from "./master-data/user-management-mitra/user-management-mitra";
import modalAddCourse from "./master-data/course-catalog/modal-add-course";
import modalAddBatch from "./master-data/course-catalog/modal-add-batch";
import modalFilter from "./master-data/course-catalog/modal-filter";
import courseCatalog from "./master-data/course-catalog/course-catalog";
import tnaMitra from "./tna-mitra/tna-mitra";
import mitraTnaReport from "./mitra-tna-report/mitra-tna-report";
import mitraEnrollment from "./mitra-enrollment/mitra-enrollment";
import mitraEnrollmentReport from "./mitra-enrollment-report/mitra-enrollment-report";
import mitraUnenrollmentReport from "./mitra-unenrollment-report/mitra-unenrollment-report";
import mitraUnenrollment from "./mitra-unenrollment/mitra-unenrollment";
import mitraAttendance from "./mitra-attendance/mitra-attendance";
import attendance from "./attendance/attendance";
import attendanceReport from "./attendance-report/attendance-report";
import idpEnrollment from "./idp/enrollment";
import courseCompletionMitra from "./course-completion-mitra/course-completion-mitra";
import courseCompletionMitraReport from "./course-completion-mitra-report/course-completion-mitra-report";
import courseCompletion from "./idp/course-completion";
import certificateReview from "./certificate-review/certificate-review";
import idpAttendance from "./idp/attendance";
import trainingCategories from "./training-categories";
import mytnaReport from "./mytna-report/mytna-report";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dashboard,
    myIdp,
    competency,
    competencyOptions,
    roleCompetency,
    trainingMethod,
    trainingProvider,
    trainingType,
    projectType,
    projectRole,
    users,
    coaching,
    training,
    trainingCategory,
    project,
    employee,
    position,
    business,
    idpPeriod,
    tnaPeriod,
    idpExamination,
    role,
    menu,
    notificationEvent,
    notificationTemplate,
    userRoleManagement,
    header,
    lsp,
    ldp,
    certificate,
    courseMapping,
    courseMappingFilters,
    courseMappingMitraFilters,
    positionLevel,
    userManagementMitra,
    modalAddCourse,
    modalAddBatch,
    modalFilter,
    courseCatalog,
    tnaMitra,
    mitraTnaReport,
    mitraEnrollment,
    mitraEnrollmentReport,
    mitraUnenrollmentReport,
    mitraUnenrollment,
    mitraAttendance,
    attendance,
    attendanceReport,
    idpEnrollment,
    courseCompletionMitra,
    courseCompletionMitraReport,
    courseCompletion,
    certificateReview,
    idpAttendance,
    trainingCategories,
    mytnaReport,
  },
});
